const SITE_TITLE = '山东省心理咨询行业协会'

export function setDocumentTitle(title) {
  const pageTitle = String(title || '').trim()
  document.title = pageTitle ? `${pageTitle} - ${SITE_TITLE}` : SITE_TITLE
}
